module.exports = __webpack_public_path__ + "static/media/fatigue.63afb062.svg";